// ============================================================
// 各端动态路由的工厂入口
//
//   createDynamicRouter({
//     staticRoutes,
//     fetchUserMenus,   // GET user/info → menus
//     layout: Layout, loginPage,
//   })
// ============================================================
import { createRouter, createWebHistory, type RouteComponent, type RouteRecordRaw, type Router } from "vue-router";
import type { UserMenuItem } from "@shared/types/user";
import { buildConstantRoutes } from "./constantRoutes";
import { installGuards } from "./installGuards";
import { registerRouter } from "./router-instance";

export interface CreateDynamicRouterOptions {
    /** 各端固定的静态路由（不走权限的少量页面，例如 / → /login） */
    staticRoutes: RouteRecordRaw[];
    layout: RouteComponent;
    loginPage: () => Promise<unknown>;
    whiteList?: string[];
    baseTitle?: string;

    /** 拉取 GET /menus 的 items */
    fetchUserMenus?: () => Promise<UserMenuItem[]>;
    /**
     * 与权限 / 动态菜单无关、但必须始终可访问的隐藏路由。
     * 适用：顶栏站内信「查看全部」等，即便 menus 不下发也不 404。
     */
    guaranteedRoutes?: RouteRecordRaw[];
    requireAuth?: boolean;
}

export function createDynamicRouter(opts: CreateDynamicRouterOptions): Router {
    const router = createRouter({
        history: createWebHistory(),
        routes: [...buildConstantRoutes({ loginPage: opts.loginPage }), ...opts.staticRoutes],
        scrollBehavior(_to, _from, savedPosition) {
            return savedPosition || { top: 0 };
        },
    });

    if (opts.guaranteedRoutes?.length) {
        opts.guaranteedRoutes.forEach(r => router.addRoute(r));
    }

    installGuards(router, {
        whiteList: opts.whiteList ?? ["/login", "/404", "/403"],
        baseTitle: opts.baseTitle || "ZM",
        layout: opts.layout,
        fetchUserMenus: opts.fetchUserMenus,
        requireAuth: opts.requireAuth ?? true,
    });

    registerRouter(router);
    return router;
}
